export const API_URL =
process.env.REACT_APP_API_URL || "https://www.fiklu.com/api";
export const ACCOUNT_KEY =
process.env.REACT_APP_ACCOUNT_KEY || "trailsidestoragetn";
